/**
 * Request limits for POST /api/v1/cite, kept dependency-free so the OpenAPI document can
 * advertise them without loading the citation formatter.
 */

/** Hard cap on batch size — each identifier is a live upstream metadata lookup. */
export const MAX_BATCH = 10;

/** Most sources one `document` request may define — a long thesis, not a corpus. */
export const MAX_DOCUMENT_SOURCES = 500;

/** Most citations one `document` request may render. */
export const MAX_DOCUMENT_CITATIONS = 1000;

/** Most sources one citation inside a `document` request may cite together. */
export const MAX_DOCUMENT_CITATION_ITEMS = MAX_BATCH;

/**
 * Most cited items across a whole `document` request. citeproc renders the document
 * synchronously, so this bounds how long one request can hold the server.
 */
export const MAX_DOCUMENT_CITED_ITEMS = 3000;

/** Longest serialized `entry` accepted in a `document` request. */
export const MAX_DOCUMENT_ENTRY_LENGTH = 20_000;
